import {
  MyCardsLayout as MyCardsLayoutComponent,
  loader,
} from 'layouts/my-cards/MyCardsLayout';

import { LayoutParams } from './__generated__/routeParams';

export { loader };
const MyCardsLayout = () => {
  return <MyCardsLayoutComponent<LayoutParams> />;
};

export default MyCardsLayout;
